import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-loads',
  templateUrl: './local-loads.component.html',
  styleUrls: ['./local-loads.component.scss']
})
export class LocalLoadsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
